import type { FaireProductEntity } from "../../entity_types/product";

export const p_mtgvutwpdj: FaireProductEntity = {
  token: "p_mtgvutwpdj",
  type: "product",
  name: "SOFT COLOR CONTRAST OVERLOCK KNIT CARDIGAN",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9ddfbe5914eea07653cef5ad6acbbc58ef156d70b34a36114644411254e00c19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc6b694db373d4886c1f9f79090f410c966cc9002640e3c9569941855d900236.jpeg",
    "https://cdn.faire.com/fastly/6124ec6272335625c97ec299e1bd8a9c6e12daa83e3dddb52d0dea85019c9b7b.jpeg",
    "https://cdn.faire.com/fastly/7d569ee01d6ddfd1ff4b616e880f0cd8c553ddb309b833930ddae54ce2378856.jpeg",
    "https://cdn.faire.com/fastly/209002b1cc128861939c3e49d6c46cee8678e2dc9023d19299ad639c0cc8f5ce.jpeg",
    "https://cdn.faire.com/fastly/de74498b8eb06b70b292c310f72c37157492ec888ad66f78b2d2a80c631af806.jpeg",
    "https://cdn.faire.com/fastly/904279d069ff5ad61678c9d2f24fac3826b4b5dd7f1b810b28ec096498ac755c.jpeg",
    "https://cdn.faire.com/fastly/c567e591b7ed4c0e418ebd4d1bb83ec46e2bd8804955a5dd6089c263fa8bf20c.jpeg",
    "https://cdn.faire.com/fastly/b9d7e16a75e584cf07adc1670deece0c8559773a1b9f2216139a655467736dd8.jpeg",
  ],
  priceDollars: 11.09,
  description:
    "SOFT COLOR CONTRAST OVERLOCK KNIT CARDIGAN\n50%COTTON, 50%POLYESTER\nSIZE  S / M / L / XL\nMADE IN CHINA\n\nWOMEN BLAZER, PUFF SLEEVE TOP, CROPPED TANK TOP, WIDE JUMPSUIT, OFF SHOULDER TOP, WHOLESALE T SHIRTS, BLACK MAXI SKIRT, V NECK BLOUSE, BASIC TOP, BABYDOLL DRESS",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:05.401Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
